<template lang="html">
  <div class="main-container">
     <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />

    <section class="main-content-section">
      <tl-tabs :tabs="tabs">
        <tl-tab>
          <upload-policy-document></upload-policy-document>
        </tl-tab>
        <tl-tab>
          <policy-documents-list></policy-documents-list>
        </tl-tab>
      </tl-tabs>
    </section>



  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  import SearchDropdown from "@/components/TlSearchDropdown.vue";
  import policyDocumentsList from './policyDocumentsList.vue';
  import uploadPolicyDocument from './uploadPolicyDocument.vue';

  export default {
    name: "policyDocument",
    components: {
      SearchDropdown,
      policyDocumentsList,
      uploadPolicyDocument
    },
    computed: {
      ...mapState({}),
      ...mapGetters({
        orgid: "onboard/organization/orgid"
      })
    },
    data() {
      return {
            breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Policy Document",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/policyDocument`
              }
        ],
        tabs: [
          {
            header: 'Upload Policy Document'
          },
          {
            header: 'Policy Document'
          }
        ],
      };
    },
    mounted() { },

    methods: {
      ...mapActions({}),

      routeToSubStep() {
        this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities` });
      },
      routeToMainStep() {
        this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation` });
      },
    }
  };
</script>

<style lang="scss" scoped>
</style>